<template>
  <div class="innerstore">
    <v-container>
      <v-row>
        <v-col cols="3">
          <div class="sub-categories-innerStore" style="background-color: white">
            <div class="title-sub-categories-innerStore">
              <span style="color: white;font-size: 15px; font-weight: bold">{{ oracle.shop_name(AllSHOP) }}</span>
            </div>
            <v-img :src="AllSHOP.shop_poster"></v-img>
            <span class="mb-2" style="font-size: 13px !important;"> {{ oracle.translate('آدرس:') }} {{
                oracle.shop_address(AllSHOP)
              }}</span>
            <div class="itemSlidbar-innerStore mb-2" v-if="AllSHOP.shop_type == 0">
              <div style="background-color: #7dc353" class="innershop-css-sent-innerStore prx-2 plx-2">
                <v-icon color="white">scatter_plot</v-icon>
                <p class="mlx-2">{{ oracle.translate('خرید اینترنتی') }}</p>
              </div>
            </div>
            <div class="itemSlidbar-innerStore mb-2" v-if="AllSHOP.shop_delivery">
              <div class="innershop-css-sent-innerStore prx-2 plx-2">
                <v-icon color="white">check</v-icon>
                <p class="mlx-2">{{ oracle.translate('ارسال با پیک') }}</p>
              </div>
            </div>
            <div class="mt-5 mb-3">
              <span style="font-size: 12px; text-align: justify">{{ oracle.shop_description(AllSHOP) }}</span>

              <div>
                                <span style="font-size: 12px;" v-for="(item, index) in AllSHOP.shop_contact"
                                      :key="index"> {{ oracle.translate(item.key) }} : {{ item.value }}  </span>
                <!--                                <span> {{AllSHOP.shop_contact[1].key}} : {{AllSHOP.shop_contact[1].value}}  </span>-->
              </div>
            </div>
            <div v-if="reviews.length > 0" class="d-flex flex-column mt-3">
              <div class="title-sub-categories-innerStore">
                <span
                    style="color: white;font-size: 15px; font-weight: bold">{{ oracle.translate('نظرات کاربران') }}</span>
              </div>
              <div class="d-flex flex-column mb-2" style="border-top: 1px solid #7ec352"
                   v-for="(item, index) in reviews" :key="index">
                <div class="d-flex flex-row align-center justify-space-between mrx-3 mlx-1">
                  <v-rating background-color="#7ec352" color="#7ec352" dense size="16px" v-model="item.comment_rate"
                            readonly></v-rating>
                  <span class="f8" style="color: #6c757d">{{ oracle.formatDate(item.create_at, false) }}</span>
                </div>
                <span class="f9" style="white-space: pre-wrap;color: #222222">{{ item.comment_text }}</span>
              </div>
            </div>
          </div>

        </v-col>

        <v-col cols="9">
          <div class="show-innerStore">
            <div class="items-show-innerStore">
              <div v-if="productCat.length > 0">
                <v-tabs class="header-tab-innerStore"
                        v-model="tab"
                        centered
                        grow
                        background-color="#7ec352"
                        color="#fff">
                  <v-tab :href="'#tab-' + (index + 1)"
                         v-for="(CatC, index) in productCat"
                         v-ripple role="button" @click="get_sub_cat(CatC.category_id, index)"
                         v-bind:key="index"> {{ oracle.category_name(CatC) }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab" class="boxTab">
                  <div v-if="AllCat.length === 0" class="progressTab-innerStore">
                    <v-progress-circular :size="50" color="success"
                                         indeterminate></v-progress-circular>
                  </div>
                  <v-tab-item v-for="(content, ii) in productCat"
                              :key="ii + 1" :value="'tab-' + (ii + 1)">
                    <v-card flat>
                      <v-container v-if="AllCat.length > 0">
                        <v-row v-for="(Baseitem, index) in AllCat" :key="index">
                          <v-col cols="12">
                            <VueSlickCarousel v-bind="settings"
                                              :ref="'slider_' + ii + '_'+index"
                                              v-if="Baseitem.products.length > 0">
                              <div class="itemproduct_cat-innerStore"
                                   v-for="(item, index) in Baseitem.products"
                                   :key="index" style="overflow-x: scroll;">
                                <router-link role="button"
                                             :to="{name: 'single', query: {id: item.product_id},}">
                                  <div class="img-itemproduct_cat-innerStore mb-2" style="position: relative">
                                    <img alt="" :src="item.product_icon"/>
                                    <span v-if="item.product_discount != null && item.product_discount > 0"
                                          class="img-discount_product">{{ item.product_discount + '%' }}</span>
                                  </div>
                                  <div class="text-itemproduct_cat-innerStore text-center"
                                       style="text-align: center !important;">
                                    <span class="multi-line mrx-auto mlx-auto text-center"
                                          :style="'text-align: center !important; color: #000000 !important;'">{{ oracle.product_title(item) }}</span>
                                    <span class="font-weight-bold mrx-auto mlx-auto"
                                          :style="'text-align: center !important; color: #7ec352 !important;'">{{
                                        oracle.format(item.product_sell_price)
                                      }} {{ oracle.translate('تومان') }}</span>
                                  </div>
                                </router-link>
                                <div v-if="isAvailable(item) && AllSHOP.shop_type == 0"
                                     class="add-to-cart_cats-innerStore-plus mrx-auto mlx-auto">
                                  <ul style="direction: rtl !important; text-align: center !important;"
                                      :style="isEN ? 'padding-right: unset !important;' : 'padding-left: unset !important;'"
                                      v-if="item.countStore > 0">
                                    <li v-ripple role="button"
                                        @click="plusItem(item)">
                                      <v-icon color="#7dc353">
                                        control_point
                                      </v-icon>
                                    </li>
                                    <li class="mrx-1 mlx-1 font-weight-bold"
                                        style="color: white; padding: 0 10px 0 10px">
                                      {{
                                        item.countStore == 0 ? ' ' :
                                            item.countStore
                                      }}
                                    </li>
                                    <li v-ripple role="button"
                                        @click="minusItem(item)">
                                      <v-icon color="#7dc353">
                                        remove_circle_outline
                                      </v-icon>
                                    </li>
                                  </ul>
                                  <v-btn v-else class="mb-2 mt-auto text-center mrx-auto mlx-auto" dark ripple
                                         style="text-align: center !important;"
                                         outlined
                                         color="#7dc353" rounded
                                         role="button"
                                         @click="plusItem(item)">
                                    {{ oracle.translate('انتخاب') }}
                                  </v-btn>
                                </div>
                                <div v-else-if="AllSHOP.shop_type == 0" class="NoN_css text-center mt-3"
                                     :style="'text-align: center !important;'">
                                  {{ oracle.translate('ناموجود') }}
                                </div>
                              </div>
                            </VueSlickCarousel>
                            <button
                                v-ripple role="button" @click="showprev(ii, index)"
                                class="btn-arrow arrow-prev">
                              <v-icon>keyboard_arrow_left</v-icon>
                            </button>
                            <button
                                v-ripple role="button" @click="showNext(ii, index)"
                                class="btn-arrow arrow-next">
                              <v-icon>keyboard_arrow_right</v-icon>
                            </button>
                          </v-col>
                          <v-col cols="12">
                            <div class="title-show-innerStore">
                              <span style="color: white;" class="font-weight-bold"> {{
                                  oracle.category_name(Baseitem)
                                }}</span>
                              <span v-if="Baseitem.category_discount != null && Baseitem.category_discount > 0"
                                    style="background: white; padding-right: 8px; font-size: 12px; padding-left: 8px; color: #7fc452; height: fit-content;"
                                    class="rounded-pill mrx-2 mlx-2">
                                {{ Baseitem.category_discount + ' ' + oracle.translate('درصد تخفیف') }}
                              </span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import oracle from "@/oracle";
import VueSlickCarousel from "vue-slick-carousel";
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: "innerStore",
  components: {VueSlickCarousel},
  data: () => ({
    dataProducts: [{id: "0", count: 0}],
    page: 1,
    empty: false,
    IsTrue: false,
    productCat: [],
    AllCat: [],
    quantities: [],
    AllSHOP: "",
    id: "",
    reviews: [],
    tab: null,
    oracle: oracle,
    isEN: oracle.isEN(),
    settings: {
      arrows: true,
      dots: false,
      autoplay: true,
      centerMode: false,
      infinite: true,
      slidesToShow: 6,
      "dotsClass": "slick-dots custom-dot-class",
      "edgeFriction": 0.35,
      "speed": 500,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      }, {
        breakpoint: 650,
        settings: {
          initialSlide: 2,
          slidesToShow: 2,
        }
      }]
    },
  }),
  methods: {
    isAvailable(item) {
      for (let i = 0; i < this.quantities.length; i++) {
        if (this.quantities[i].product_id == item.product_id) {
          return this.quantities[i].product_quantity > 0
        }
      }
      return false
    },
    minusItem(item) {
      if (item.countStore == 0) {
        return;
      }
      item.countStore--;
      oracle.removeFromBasket(item.product_id);
      this.$root.$emit("checkitem");
    },
    plusItem(item) {
      let quantity = 0
      for (let i = 0; i < this.quantities.length; i++) {
        if (this.quantities[i].product_id == item.product_id) {
          quantity = this.quantities[i].product_quantity
        }
      }
      if (item.countStore >= quantity) {
        return;
      }
      if (oracle.getShop() != null && oracle.getShop() != this.id) {
        this.showError(item)
        return;
      } else {
        oracle.setShop(this.id);
      }
      item.countStore++;
      oracle.addToBasket(item.product_id);
      this.$root.$emit("checkitem");
    },
    showError(item) {
      oracle.showMessage(oracle.translate('در صورت ادامه سبد خرید شما خالی و فروشگاه شما تغییر خواهد کرد، ادامه میدهید؟'),
          oracle.translate('ادامه میدهم'), () => {
            oracle.clearBasket()
            oracle.setShop(null)
            this.plusItem(item)
          })
    },
    showNext(i, k) {
      this.$refs["slider_" + i + "_" + k][0].next();
    },
    showprev(i, k) {
      this.$refs["slider_" + i + "_" + k][0].prev();
    },
    plus(id) {
      this.dataProducts.forEach((item) => {
        if (item.id === id) item.count += 1;
      });
    },
    minus(id) {
      this.dataProducts.forEach((item) => {
        if (item.id === id) item.count -= 1;
      });
    },
    GetCatProducts(response) {
      this.productCat = response.data;
      this.get_sub_cat(response.data[0].category_id);
    },
    GetSubCat(response, category) {
      category.subcat = response.data;
      this.IsTrue = true;
      this.IsTrue = false;
    },
    get_sub_cat(id, index) {
      this.AllCat = [];
      oracle.axios(
          "productCategory/getList",
          {offset_by: 0, limit_by: 1000, order_by: "priority", parent_by: id},
          this.GetSUBCat
      );
    },
    GetSUBCat(response) {
      for (let i = 0; i < response.data.length; i++) {
        response.data[i].products = [];
      }
      this.AllCat = response.data;
      for (let i = 0; i < this.AllCat.length; i++) {
        oracle.axios(
            "product/getList",
            {
              offset_by: 0,
              limit_by: 50,
              shop_by: this.AllSHOP != null ? this.AllSHOP.shop_code : null,
              order_by: "priority",
              parent_by: this.AllCat[i].category_id,
            },
            this.getSubCatData,
            null,
            null,
            this.AllCat[i]
        );
      }
    },
    getSubCatData(response, category) {
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < this.quantities.length; j++) {
          if (this.quantities[j].product_id == response.data[i].product_id) {
            response.data[i].qty = this.quantities[j].product_quantity
          }
        }
        let qty = response.data[i].qty
        let count = oracle.getCount(response.data[i].product_id, this.id)
        response.data[i].countStore = count > qty ? qty : count
      }
      category.products = response.data;
      this.Istrue = true;
      this.Istrue = false;
    },
    GetQuantities(response) {
      let isEmpty = this.quantities.length == 0
      this.quantities = response.data
      if (isEmpty) {
        oracle.axios(
            "productCategory/getList",
            {
              offset_by: 0,
              limit_by: 1000,
              order_by: "priority",
            },
            this.GetCatProducts
        );
      } else {
        for (let i = 0; i < this.AllCat.length; i++) {
          for (let j = 0; j < this.AllCat[i].products.length; j++) {
            let product = this.AllCat[i].products[j]
            for (let k = 0; k < this.quantities.length; k++) {
              if (this.quantities[k].product_id == product.product_id) {
                let qty = this.quantities[k].product_quantity
                let count = oracle.getCount(product.product_id, this.id)
                product.countStore = count > qty ? qty : count
                break
              }
            }
          }
        }
      }
    },
    runQty() {
      oracle.axios("shop/getQuantities", {shop_id: this.$route.query.id}, this.GetQuantities);
    },
    fetchPage() {
      this.id = this.$route.query.id
      oracle.axios("shop/getOne", {shop_id: this.$route.query.id}, (res) => {
        this.AllSHOP = res.data;
        this.runQty()
      });
      oracle.axios("review/getList", {shop_id: this.$route.query.id}, (response) => {
        this.reviews = response.data
      });
    }
  },
  mounted() {
    this.fetchPage()
    this.$root.$on('checkitem_header', () => {
      if (this.$route.query.id != null) {
        oracle.axios("shop/getQuantities", {shop_id: this.$route.query.id}, this.GetQuantities);
      }
    })
  }, watch: {
    '$route.params': 'fetchPage'
  }
};
</script>
<style>

.innerstore .NoN_css {
  color: red;
  font-size: 13px;
}

.innerstore .btn-arrow {
  position: absolute;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  justify-self: center;
  /*height: 11.3%;*/
  /*top: 0;*/
  z-index: 3;
  background-color: #7dc353;
}

.innerstore .btn-arrow i {
  color: #ffffff !important;
  font-size: 45px !important;
}

.innerstore .arrow-prev {
  left: 0;
}

.innerstore .arrow-next {
  right: 0;
}

.innerstore .image-slide-single img {
  width: 50%;
  height: 50%;
}

.innerstore .image-slide-single {
  width: 50%;
  height: 50%;
}

.innerstore .itemproduct_cat-innerStore {
  position: relative;
  text-align: center !important;
  width: 100% !important;
  height: 100%;
  margin: 0 auto;
}

.innerstore .img-itemproduct_cat-innerStore {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  overflow: hidden;
  margin: 0 auto;
}

.innerstore .add-to-cart_cats-innerStore-plus ul {
  display: flex;
  z-index: 1100;
  justify-content: center;
  flex-direction: row;
  direction: rtl !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.innerstore .add-to-cart_cats-innerStore-plus button {
  height: 25px !important;
  font-size: 11px !important;
}

.innerstore .add-to-cart_cats-innerStore-plus {
  margin-top: 10px;
  text-align: center !important;
}

.innerstore .add-to-cart_cats-innerStore-plus i {
  transform: scale(0.8);
}

.innerstore .img-itemproduct_cat-innerStore img {
  width: 100%;
  height: 100%;
}

.innerstore .text-itemproduct_cat-innerStore {
  display: flex;
  flex-direction: column;
}

.innerstore .items-show-cat a {
  color: #333;
}

.innerstore .text-itemproduct_cat-innerStore h6 {
  font-size: 12px;
  margin-top: 8px;
}

.innerstore .text-itemproduct_cat-innerStore span {
  font-size: 14px;
  margin-top: 5px;
}

.innerstore .add-to-cart_cat {
  position: absolute;
  top: 15px;
  left: -30px;
  z-index: 10;
}

.innerstore .add-to-cart_cats-innerStore {
  position: absolute;
  top: 15px;
  left: 25px;
  z-index: 10;
}

.innerstore .add-to-cart_cat ul {
  display: flex;
  border: 2px solid #7ec352;
  background: #fff;
  border-radius: 25px;
  justify-content: space-between;
  padding: 0 3px !important;
}

.innerstore .add-to-cart_cat ul li .v-icon {
  font-size: 18px !important;
}

.innerstore .add-to-cart_cat ul li:nth-child(2) {
  padding: 0 5px;
}

.innerstore .v-tabs--icons-and-text > .v-tabs-bar {
  height: 42px !important;
}

.innerstore .itemSlidbar-innerStore {
  display: flex;
  margin-right: 10px;
  margin-left: 10px;
  justify-content: flex-start;
}

.innerstore .innershop-css-sent-innerStore {
  background-color: #2ab0f7;
  width: fit-content;
  height: 25px;
  border-radius: 20px;
  display: flex !important;
  color: white;
  font-size: 10px;
  margin-left: 10px;
  margin-right: 10px;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.innerstore .innershop-css-sent-innerStore p {
  font-weight: bold;
  margin: 0;
}

.innerstore .innershop-css-sent-innerStore .v-icon {
  font-size: 12px;
  margin-left: 5px;
  margin-right: 5px;
}

.innerstore {
  background: #fff;
  width: 100%;
}

.innerstore .sub-categories-innerStore {
  min-height: 450px;
  border: 2px solid #7ec352;
  border-radius: 3px;
}

.innerstore .sub-categories-innerStore span {
  padding: 10px 15px;
  display: flex;
}

.innerstore .title-sub-categories-innerStore {
  color: #fff;
  line-height: 20px;
  padding: 0 5px;
  font-size: 15px;
  background-color: #7ec352;
}

.innerstore .sub-categories-innerStore ul {
  display: flex;
  padding: 15px;
  font-size: 12px;
  margin: 0;
  flex-direction: column;
}

.innerstore .item-sub-categories-innerStore {
  padding-bottom: 10px;
}

.innerstore .item-sub-categories-innerStore span {
  font-size: 14px;
}

.innerstore .item-sub-categories-innerStore ul {
  padding-right: 15px;
  padding-left: 15px;
}

.innerstore .item-sub-categories-innerStore ul li {
  padding-right: 15px;
  padding-left: 15px;
  line-height: 30px;
  position: relative;
  transition: color ease 0.2s;
}

.innerstore .item-sub-categories-innerStore > ul li:before {
  content: "•";
  color: #7ec352;
  position: absolute;
  right: 0;
  font-size: 25px;
  line-height: 0;
  top: 19px;
}

.innerstore .item-sub-categories-innerStore ul li a {
  color: #333;
}

.innerstore .show-innerStore {
  width: 100%;
  display: flex;
  justify-content: center;
  border-radius: 5px;
  overflow: hidden;
}

.innerstore .title-show-innerStore {
  background-color: #7ec352;
  height: 45px;
  align-items: center;
  color: #fff;
  padding: 0 10px;
  font-size: 15px;
  border-radius: 3px 3px 0 0;
  border: 2px solid #7ec352;
  border-bottom: 0;
  display: flex;
  justify-content: center;
  flex-direction: row;
  cursor: pointer;
}

.innerstore .bg-innerStore {
  width: 100%;
  height: 500px;
}

.innerstore .bg-innerStore img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #fff;
}

.innerstore .header-tab-innerStore,
.innerstore .boxTab,
.innerstore .items-show-innerStore {
  width: 100%;
}

.innerstore .header-tab-innerStore .v-item-group {
  direction: initial !important;
}

.innerstore .header-tab-innerStore {
  direction: initial !important;
}

.innerstore .v-slide-group__wrapper {
  direction: initial !important;
}

.innerstore #bg-innerStore {
  padding: 0;
}

.innerstore .itemproduct {
  position: relative;
  text-align: center !important;
  width: 160px;
  margin: 30px auto auto;
  flex: 0 0 21%;
  display: flex;
}

.innerstore .img-itemproduct {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
}

.innerstore .img-itemproduct img {
  width: 100%;
  height: 100%;
}

.innerstore .text-itemproduct {
  display: flex;
  flex-direction: column;
}

.innerstore .items-show-innerStore a {
  color: #333;
}

.innerstore .text-itemproduct h6 {
  font-size: 13px;
  margin-top: 8px;
}

.innerstore .text-itemproduct span {
  font-size: 12px;
  color: #7ec352;
  margin-top: 5px;
}

.innerstore .add-to-cart {
  position: absolute;
  top: 5px;
  left: 10px;
}

.innerstore .add-to-cart ul {
  display: flex;
  border: 2px solid #7ec352;
  background: #fff;
  border-radius: 25px;
  justify-content: space-between;
  padding: 0 3px !important;
}

.innerstore .add-to-cart ul li .v-icon {
  font-size: 18px !important;
}

.innerstore .add-to-cart ul li:nth-child(2) {
  padding: 0 5px;
}

.innerstore .footer-show-innerStore {
  margin: 20px 0;
}

.innerstore .bdginnerStore {
  background-color: #a7d38d;
  color: #fff;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  font-size: 12px;
}

.innerstore .bdginnerStore p {
  margin: 0;
  display: flex;
  align-items: center;
}

.innerstore .items-show-innerStore heme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #000;
  letter-spacing: inherit;
}

.innerstore .v-tab--active {
  color: white !important;
}

.innerstore .slick-slider .slick-list {
  direction: ltr !important;
}

.innerstore .progressTab-innerStore {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.innerstore .v-slide-group__content {
  direction: rtl !important;
}

.innerstore .img-discount_product {
  position: absolute;
  right: 1.5rem;
  top: 0;
  font-size: 12px;
  background: #7fc452;
  text-align: center !important;
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
  color: white;
  font-weight: bold;
  border-radius: 100%;
  padding-top: 4px;
}
</style>
